/**
 * TRADER_GLOSSARY — plain-English labels + definitions for the Layer 11
 * behavioural-guardrail jargon shown on Settings > Behavioural guardrails
 * (2026-09-01 directive: "Kill-Switch Glossary Everywhere"). Reuses the
 * same `reading_level` account preference as the Investment Strategy /
 * Psychometric questionnaires — 'basic' shows the plain label + tooltip,
 * 'intermediate'/'advanced' show the original technical term undecorated.
 */
export const TRADER_GLOSSARY = {
    mandatory_sl: {
        basic: "Stop-loss required",
        technical: "Mandatory Hard Stop-Loss",
        definition: "Every buy order needs a stop-loss attached — an automatic sell if the price drops too far, so losses can't run unchecked.",
    },
    dual_rationale: {
        basic: "Two reasons required",
        technical: "Dual-Rationale Gate",
        definition: "Before you can buy, you must give two independent reasons for the trade — stops hype-driven entries.",
    },
    immutable_sl: {
        basic: "Stop-loss can't be loosened",
        technical: "Immutable Stop-Loss Floor",
        definition: "You can move your stop-loss to protect more of your money, but never further away — that would risk more.",
    },
    reward_risk: {
        basic: "Profit target must beat the risk",
        technical: "Minimum 2:1 Reward-to-Risk",
        definition: "Your potential profit must be at least twice your potential loss on every trade — rejected if it isn't.",
    },
    no_averaging_down: {
        basic: "Can't buy more of a loser",
        technical: "No Averaging Down",
        definition: "Blocks buying more of a stock you already hold at a loss — adding to a losing bet usually makes things worse, not better.",
    },
    circuit_breaker: {
        basic: "Daily loss pause",
        technical: "Daily 3% Circuit Breaker",
        definition: "If you lose 3% of your account in a day, trading pauses for 24 hours so you don't dig a deeper hole.",
    },
    drawdown_probation: {
        basic: "Weekly loss pause",
        technical: "Weekly 6% Drawdown Probation",
        definition: "If you lose 6% of your account within 7 days, trading pauses until you complete a practice drill.",
    },
    post_trade_lock: {
        basic: "Cool-off after big moves",
        technical: "Post-Trade 2h De-escalation",
        definition: "After a trade moves your account ±5% or more, there's a 2-hour pause so emotions settle before your next trade.",
    },
    kill_switch: {
        basic: "Emergency shut-off",
        technical: "Kill-switch",
        definition: "A one-time action that turns off every guardrail rule at once — flagged on your institution's compliance dashboard.",
    },
};
